import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../environments/environment'
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router'
import { BehaviorSubject } from 'rxjs/BehaviorSubject'
import { ProspectModel } from '../models/track/prospect.model'
import { ProspectsModel } from '../models/track/prospects.model'
import { PageEvent } from '@angular/material'

@Injectable()
export class TrackProspectsService implements Resolve<Observable<any>> {
  private readonly url = environment.track_url + '/api/prospects'

  private prospect: ProspectModel
  private prospects: ProspectsModel

  public filters: any

  prospectsChanged: BehaviorSubject<ProspectsModel> = new BehaviorSubject<ProspectsModel>(undefined)
  prospectChanged: BehaviorSubject<ProspectModel> = new BehaviorSubject<ProspectModel>(undefined)

  constructor(private _httpClient: HttpClient) {
    this.filters = {
      limit: 10,
      offset: 0,
    }
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const view = route.params['view']
    switch (view) {
      case 'new':
        this.filters.status = 1
        break
      case 'accepted':
        this.filters.status = 7
        break
      case 'rejected':
        this.filters.status = 4
        break
      case 'processed':
        this.filters.status = 9
        break
      default:
        delete this.filters.status
        break
    }
    delete this.filters.page
    return this.browse()
  }

  /**
   * Get a list of administrations
   * @returns {Observable<ProspectsModel>}
   */
  public browse() {
    return this._httpClient
      .get<ProspectsModel>(this.url, { params: this.filters })
      .map(response => {
        this.prospects = new ProspectsModel(response)
        this.prospectsChanged.next(this.prospects)
        return this.prospects
      })
  }

  public accept(prospect: ProspectModel) {
    return this._httpClient.post(this.url + '/' + prospect.id + '/accept', {}).subscribe(() => {
      this.browse().subscribe()
    })
  }

  changeFilter(event?: PageEvent) {
    this.filters.page = event.pageIndex + 1
    this.filters.limit = event.pageSize
    this.browse().subscribe()
  }

  /**
   * Search.
   * @param search
   */
  changeSearch(search: string) {
    this.filters.search = search
    if (search === '') {
      delete this.filters.search
    }
    this.browse().subscribe()
  }
}



// WEBPACK FOOTER //
// ./src/app/main/services/track.prospects.service.ts